import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { getDeviceInfo } from '@breezeventures/utils/get-metadata';
import { useMutation } from '@tanstack/react-query';

import type {
  CreatePartnerApplicationRequest,
  PartnerApplicationResponse,
} from '../model';

export const useCreatePartnerApplication = () => {
  return useMutation({
    mutationFn: (data: CreatePartnerApplicationRequest) => {
      return makeRequest<ResponseSuccess<PartnerApplicationResponse>>({
        url: `${config.apiHost}/merchant-origination/api/v1/public/partner/applications/create`,
        credentials: 'include',
        payload: {
          ...data,
          deviceData: getDeviceInfo(),
        },
      }).then((response) => response.payload);
    },
  });
};
